<!-- src/components/ui/StatusBadge.vue -->
<template>
  <span :class="badgeClass">{{ statusLabel }}</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  status: {
    type: [Number, String],
    required: true
  }
})

const statusMap = {
  0: { label: 'Pending', class: 'bg-yellow-100 text-yellow-800' },
  1: { label: 'Verified', class: 'bg-green-100 text-green-800' },
  2: { label: 'Rejected', class: 'bg-red-100 text-red-800' },
  3: { label: 'In Progress', class: 'bg-blue-100 text-blue-800' },
}

const statusLabel = computed(() => statusMap[props.status]?.label ?? 'Unknown')
const badgeClass = computed(() => `px-2 py-1 rounded text-xs font-medium ${statusMap[props.status]?.class ?? 'bg-gray-100 text-gray-800'}`)
</script>